import styled from 'styled-components';

import { Text16SB } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const LoadingText = styled(Text16SB)`
  margin-left: 10px;
  color: ${ct({ Dark: Colors.Grey, Light: Colors.Grey })};
`;
